import { downloadBlob } from 'console/utils/download-files/download-blob';
import { toByteArray } from 'base64-js';
import { getFileType } from 'console/utils/download-files/download_file';
import { getAPIErrorMessage } from 'api';
const initial = {
    open: false,
    randomKey: Math.random().toString(),
    suggested_amount_x100: null,
    pay_intent: null,
    auto_payment: false,
    loading: false,
    success: null,
    fail: null,
};
export function topUpDialogReducer(state = initial, action) {
    switch (action.type) {
        case 'OPEN_TOPUP_DIALOG':
            return {
                ...state,
                open: true,
                randomKey: Math.random().toString(),
                auto_payment: action.auto_payment ?? state.auto_payment,
                suggested_amount_x100: action.suggested_amount_x100,
                pay_intent: action.pay_intent,
                loading: false,
                success: null,
                fail: null,
            };
        case 'CLOSE_TOPUP_DIALOG':
            return {
                ...state,
                open: false,
            };
        case 'REQUEST_TOPUP__REQUEST':
            return {
                ...state,
                loading: true,
                success: null,
                fail: null,
            };
        case 'REQUEST_TOPUP__OK':
            if (action.data.type == 'auto_invoice' && action.data.invoice_pdf != null) {
                downloadBlob(toByteArray(action.data.invoice_pdf), action.data.invoice_filename, getFileType(action.data.invoice_filename), false);
            }
            return {
                ...state,
                loading: false,
                success: action.data,
                open: false,
            };
        case 'REQUEST_TOPUP__FAIL':
            return {
                ...state,
                loading: false,
                fail: getAPIErrorMessage(action.error, 'Не удалось пополнить'),
            };
        default:
            return state;
    }
}
